/**
 * Admin views: used by administator to manage application
 * Path: `@/views/administration`
 */

import multiguard from "vue-router-multiguard"
import { requireCompanyOwner } from "@/utils/middleware"

const AdministrationUsers = () => import("@/views/administration/AdministrationUsers.vue")
const AdministrationUsersPending = () =>
  import("@/views/administration/AdministrationUsersPending.vue")

const AdministrationDrawer = () => import("@/components/layouts/core/AdministrationDrawer.vue")

export default [
  {
    path: "/administration",
    name: "Administration",
    redirect: { name: "AdministrationUsers" }
  },
  {
    path: "/administration/users",
    component: AdministrationUsers,
    name: "AdministrationUsers",
    beforeEnter: multiguard([requireCompanyOwner]),
    meta: {
      layout: "default",
      drawer: AdministrationDrawer
    }
  },
  {
    path: "/administration/pending",
    component: AdministrationUsersPending,
    name: "AdministrationUsersPending",
    beforeEnter: multiguard([requireCompanyOwner]),
    meta: {
      layout: "default",
      drawer: AdministrationDrawer
    }
  }
]
